module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/prevention_infobanner02.787d59b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/product_info/prevention_infobanner02.jpg
// module id = q5WE
// module chunks = 0